import React from 'react';
import { motion } from 'framer-motion';
import { FiClock, FiMapPin, FiExternalLink, FiTag } from 'react-icons/fi';

export default function SmallMarket({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS (API Real + Mock)
    const title = data?.titulo || data?.title || 'Ativo Marketplace';
    const price = data?.preco || data?.price;
    const location = data?.bairro || data?.location || 'Setor Local';
    const city = data?.cidade || '';
    const mainImage = data?.imagensDestaque?.[0] || data?.image || 'https://images.unsplash.com/photo-1570129477492-45c003edd2be';
    
    // Data fictícia ou real para o efeito de "Postado agora"
    const timestamp = data?.createdAt ? new Date(data.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '14:20';

    const formattedPrice = typeof price === 'number' 
        ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 })
        : price || 'Consulte';

    return (
        <motion.div 
            whileHover={{ scale: 1.02, x: 5 }}
            className="flex gap-5 p-4 rounded-[2rem] border transition-all duration-300 group cursor-pointer relative overflow-hidden"
            style={{ 
                backgroundColor: 'var(--bg-card)', 
                borderColor: 'var(--border-color)',
                boxShadow: '0 10px 30px -10px rgba(0,0,0,0.05)'
            }}
        >
            {/* 📸 THUMBNAIL QUADRADA (STREET VIEW) */}
            <div className="w-36 h-36 rounded-2xl overflow-hidden flex-shrink-0 relative shadow-inner bg-zinc-100">
                <img 
                    src={mainImage} 
                    alt={title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
                />
                <div className="absolute top-2 left-2 px-2 py-1 rounded-lg bg-black/60 backdrop-blur-md text-[7px] text-white font-black uppercase tracking-widest border border-white/10 flex items-center gap-1">
                    <FiTag size={8} style={{ color }} /> Classificado
                </div>
            </div>

            {/* 📄 INFO CORE: HIERARQUIA AGRESSIVA */}
            <div className="flex flex-col justify-between py-2 flex-1 min-w-0">
                <div className="space-y-1">
                    <div className="flex justify-between items-start gap-2">
                        <h4 className="font-black text-sm text-auto leading-tight uppercase line-clamp-2 tracking-tight group-hover:text-accent transition-colors"
                            style={{ color: 'var(--text-primary)' }}>
                            {title}
                        </h4>
                        <FiExternalLink className="opacity-0 group-hover:opacity-30 transition-opacity text-auto shrink-0" size={14} />
                    </div>
                    
                    <div className="flex items-center gap-2">
                        <FiMapPin className="text-auto opacity-30" size={10} />
                        <p className="text-[10px] text-auto opacity-40 font-bold uppercase tracking-tighter truncate">
                            {location} {city && `// ${city}`}
                        </p>
                    </div>
                </div>

                {/* AREA DE VALOR E TIMING */}
                <div className="flex justify-between items-end border-t border-auto pt-3 opacity-90" style={{ borderColor: 'var(--border-color)' }}>
                    <div className="flex flex-col">
                        <span className="text-[8px] font-black uppercase tracking-widest opacity-20 text-auto mb-0.5">Oportunidade</span>
                        <span className="text-xl font-black tracking-tighter" style={{ color: color || 'var(--accent-color)' }}>
                            {formattedPrice}
                        </span>
                    </div>
                    
                    <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-auto opacity-20 border border-auto">
                        <FiClock size={10} className="text-auto" />
                        <span className="text-[8px] font-black uppercase tracking-tighter text-auto">
                            Hoje {timestamp}
                        </span>
                    </div>
                </div>
            </div>

            {/* Linha Lateral de Categoria */}
            <div className="absolute left-0 top-1/4 bottom-1/4 w-1 rounded-r-full opacity-0 group-hover:opacity-100 transition-opacity"
                 style={{ backgroundColor: color || 'var(--accent-color)' }} />
        </motion.div>
    );
}